import { render, staticRenderFns } from "./fourPage.vue?vue&type=template&id=3051225f&scoped=true"
import script from "./fourPage.vue?vue&type=script&lang=js"
export * from "./fourPage.vue?vue&type=script&lang=js"
import style0 from "./fourPage.vue?vue&type=style&index=0&id=3051225f&prod&lang=scss&scoped=true"
import style1 from "./fourPage.vue?vue&type=style&index=1&id=3051225f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3051225f",
  null
  
)

export default component.exports